module.exports = __webpack_public_path__ + "img/sphone_background.59c87821.svg";